/* Flip-countdown (vanilla, без jQuery). Портирован с nup-banners/tp-card/timer.js.
   Evergreen: обратный отсчёт 3 дня (72ч), дедлайн хранится в localStorage; по нулю — сброс.
   Разметка: <ul class="flip-clock" data-flip><li class="flip-item-hours">00</li>
             <li class="flip-item-minutes">00</li><li class="flip-item-seconds">00</li></ul> */
(function () {
  var KEY = 'tm_offer_dl3';
  var WINDOW_MS = 3 * 24 * 60 * 60 * 1000; /* умный дедлайн на 3 дня, как в референсе */
  var MONTHS = {
    en: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    ru: ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря']
  };
  function writeDate(dl) {
    var lang = (window.QUIZ_LANG || 'en').toLowerCase().slice(0, 2);
    var m = MONTHS[lang] || MONTHS.en;
    var d = new Date(dl);
    var str = (lang === 'ru') ? (d.getDate() + ' ' + m[d.getMonth()]) : (m[d.getMonth()] + ' ' + d.getDate());
    document.querySelectorAll('[data-flip-date]').forEach(function (el) { el.textContent = str; });
  }

  function tens(n) { return Math.floor(n / 10); }
  function units(n) { return n % 10; }

  function buildUnit(li, value) {
    li.textContent = '';
    var d = [tens(value), units(value)];
    for (var i = 0; i < 2; i++) {
      var fd = document.createElement('div'); fd.className = 'flip-digit';
      var nx = document.createElement('span'); nx.className = 'flip-digit-next'; nx.setAttribute('data-digit', d[i]);
      var cu = document.createElement('span'); cu.className = 'flip-digit-current'; cu.setAttribute('data-digit', d[i]);
      fd.appendChild(nx); fd.appendChild(cu); li.appendChild(fd);
    }
  }

  function setUnit(li, value, animate) {
    var d = [tens(value), units(value)];
    var fds = li.querySelectorAll('.flip-digit');
    for (var i = 0; i < 2; i++) {
      var fd = fds[i]; if (!fd) continue;
      var cur = fd.querySelector('.flip-digit-current');
      var nx = fd.querySelector('.flip-digit-next');
      var nd = String(d[i]);
      if (cur.getAttribute('data-digit') === nd) continue;
      if (!animate) { cur.setAttribute('data-digit', nd); nx.setAttribute('data-digit', nd); continue; }
      nx.setAttribute('data-digit', nd);
      fd.classList.add('flipping');
      (function (fd, cur, nd) {
        setTimeout(function () { cur.setAttribute('data-digit', nd); fd.classList.remove('flipping'); }, 850);
      })(fd, cur, nd);
    }
  }

  function deadline() {
    var now = Date.now();
    var raw; try { raw = localStorage.getItem(KEY); } catch (e) { raw = null; } /* приватный режим/куки off */
    var dl = parseInt(raw || '0', 10);
    if (!dl || dl <= now) { dl = now + WINDOW_MS; try { localStorage.setItem(KEY, dl); } catch (e) {} }
    return dl;
  }

  function init(el) {
    if (el.__flip) return; el.__flip = true;
    var liH = el.querySelector('.flip-item-hours');
    var liM = el.querySelector('.flip-item-minutes');
    var liS = el.querySelector('.flip-item-seconds');
    if (!liH || !liM || !liS) { el.__flip = false; return; }
    var dl = deadline();
    writeDate(dl);
    var rem = function () { return Math.max(0, Math.floor((dl - Date.now()) / 1000)); };
    var t = rem();
    var h = Math.floor(t / 3600) % 100, m = Math.floor(t / 60) % 60, s = t % 60;
    buildUnit(liH, h); buildUnit(liM, m); buildUnit(liS, s);
    var prev = { h: h, m: m, s: s };
    setInterval(function () {
      var tt = rem();
      if (tt <= 0) { dl = Date.now() + WINDOW_MS; try { localStorage.setItem(KEY, dl); } catch (e) {} writeDate(dl); tt = rem(); }
      var nh = Math.floor(tt / 3600) % 100, nm = Math.floor(tt / 60) % 60, ns = tt % 60;
      if (ns !== prev.s) { setUnit(liS, ns, true); prev.s = ns; }
      if (nm !== prev.m) { setUnit(liM, nm, true); prev.m = nm; }
      if (nh !== prev.h) { setUnit(liH, nh, true); prev.h = nh; }
    }, 1000);
  }

  /* Простой счётчик в старом стиле «04h : 27m : 07s» — тот же дедлайн, что и flip-часы.
     Разметка: <span data-countdown><b data-cd="h">00</b>h : <b data-cd="m">00</b>m : <b data-cd="s">00</b>s</span> */
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function initCd(el) {
    if (el.__cd) return; el.__cd = true;
    var H = el.querySelector('[data-cd="h"]'), M = el.querySelector('[data-cd="m"]'), S = el.querySelector('[data-cd="s"]');
    if (!H || !M || !S) { el.__cd = false; return; }
    var dl = deadline();
    function tick() {
      var t = Math.max(0, Math.floor((dl - Date.now()) / 1000));
      if (t <= 0) { dl = Date.now() + WINDOW_MS; try { localStorage.setItem(KEY, dl); } catch (e) {} t = Math.max(0, Math.floor((dl - Date.now()) / 1000)); }
      H.textContent = pad(Math.floor(t / 3600));
      M.textContent = pad(Math.floor(t / 60) % 60);
      S.textContent = pad(t % 60);
    }
    tick();
    setInterval(tick, 1000);
  }

  function boot() {
    document.querySelectorAll('[data-flip]').forEach(init);
    document.querySelectorAll('[data-countdown]').forEach(initCd);
  }
  if (document.readyState !== 'loading') { boot(); } else { document.addEventListener('DOMContentLoaded', boot); }
  setInterval(boot, 1500); /* квиз показывает таймер позже — добиваем поллингом */
})();
